import find from 'lodash/find'
import { formatCurrency } from '../../../formatters'
import { multiplierField } from '../multiplier'

export default discounts => [
  {
    name: 'Discount',
    prop: 'discount_id',
    type: 'select',
    options: discounts.map(discount => ({
      name: `${discount.code} - ${discount.flat_amount ? formatCurrency(discount.flat_amount) : discount.percent_amount + '%'}`,
      value: discount.id
    })),
    onChange: (id, resource) => {
      const discount = find(discounts, { id })
      if (discount.flat_amount) {
        resource.discount_flat_amount = discount.flat_amount.toFixed(2)
      } else {
        resource.discount_percent_amount = discount.percent_amount
      }
    }
  },
  multiplierField
]
